/* Save this file as: assets/cart-popup.js
   Link it in theme.liquid, right before </body>, with:
   <script src="{{ 'cart-popup.js' | asset_url }}" defer></script>

   Behavior:
   - Popup opens ONLY when an item is successfully added to the cart
     (never on removal / quantity decrease).
   - Progress bar: odd total cart quantity -> 50%, even quantity -> 100%.
   - "Claim Your Offer" button is disabled/unclickable at 50%, and
     enabled (redirects to /checkout) at 100%. This resets every time
     the cart total quantity changes, so customers can claim it again
     every time they reach an even count (2, 4, 6...).
*/

(function () {
  var overlay, popup, itemsWrap, subtotalEl, progressFill, progressMsg, claimBtn;

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function init() {
    overlay = document.getElementById('cart-popup-overlay');
    popup = document.getElementById('cart-popup');
    itemsWrap = document.getElementById('cart-popup-items');
    subtotalEl = document.getElementById('cart-popup-subtotal-amount');
    progressFill = document.getElementById('cart-popup-progress-fill');
    progressMsg = document.getElementById('cart-popup-progress-message');
    claimBtn = document.getElementById('cart-popup-claim-btn');

    if (!overlay) return; // snippet not on this page

    document.getElementById('cart-popup-close').addEventListener('click', closePopup);
    document.getElementById('cart-popup-continue').addEventListener('click', function (e) {
      e.preventDefault();
      closePopup();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    claimBtn.addEventListener('click', function () {
      if (claimBtn.disabled) return;
      window.location.href = '/checkout';
    });

    hookAddToCart();
  }

  function openPopup() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    suppressNativeCartPopup();
  }

  // Closes/hides Shopify's built-in cart notification or drawer, in case
  // the theme's own JS still tries to toggle it open (the CSS rule hides
  // it visually, this clears any "open" state so it can't intercept focus
  // or scroll either).
  function suppressNativeCartPopup() {
    var selectors = [
      'cart-notification',
      '.cart-notification',
      '#cart-notification',
      '#CartNotification',
      'cart-drawer',
      '.cart-drawer',
      '#CartDrawer'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      el.classList.remove('active', 'is-open', 'animate');
      if (typeof el.close === 'function') {
        try { el.close(); } catch (e) {}
      }
    });
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
  }

  // Pull latest cart state and render + open the popup.
  function refreshCartAndShow() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        openPopup();
      })
      .catch(function (err) {
        console.error('Cart popup: failed to load cart', err);
      });
  }

  function renderCart(cart) {
    // --- Items list ---
    itemsWrap.innerHTML = '';
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'cart-popup-item';

      var img = document.createElement('img');
      img.className = 'cart-popup-item-image';
      img.src = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_100x$1$2') : '';
      img.alt = item.product_title;
      row.appendChild(img);

      var info = document.createElement('div');
      info.className = 'cart-popup-item-info';

      var title = document.createElement('p');
      title.className = 'cart-popup-item-title';
      title.textContent = item.product_title;
      info.appendChild(title);

      if (item.variant_title) {
        var variant = document.createElement('p');
        variant.className = 'cart-popup-item-variant';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }

      var priceRow = document.createElement('div');
      priceRow.className = 'cart-popup-item-price';
      priceRow.textContent = formatMoney(item.final_price);
      if (item.original_price !== item.final_price) {
        var compare = document.createElement('span');
        compare.className = 'compare';
        compare.textContent = formatMoney(item.original_price);
        priceRow.appendChild(compare);
      }
      info.appendChild(priceRow);

      var qty = document.createElement('p');
      qty.className = 'cart-popup-item-qty';
      qty.textContent = 'Qty: ' + item.quantity;
      info.appendChild(qty);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'cart-popup-item-remove';
      removeBtn.setAttribute('aria-label', 'Remove ' + item.product_title);
      removeBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="3 6 5 6 21 6"></polyline>' +
        '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>' +
        '<path d="M10 11v6"></path><path d="M14 11v6"></path>' +
        '<path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>' +
        '</svg><span>Remove</span>';
      removeBtn.addEventListener('click', function () {
        removeItem(item.key);
      });
      info.appendChild(removeBtn);

      row.appendChild(info);
      itemsWrap.appendChild(row);
    });

    // --- Subtotal ---
    subtotalEl.textContent = formatMoney(cart.total_price);

    // --- BOGO progress bar ---
    updateProgress(cart.item_count);
  }

  // Removes a line item from the cart (quantity -> 0) and refreshes the
  // popup contents in place, without closing it.
  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function (err) {
        console.error('Cart popup: failed to remove item', err);
      });
  }

  function updateProgress(itemCount) {
    var isEven = itemCount > 0 && itemCount % 2 === 0;

    progressFill.classList.remove('is-half', 'is-full');
    if (itemCount > 0) {
      // Wait one frame so the browser registers the class removal
      // (0% state) before adding the new class — this is what makes
      // the width transition fire reliably every single time.
      window.requestAnimationFrame(function () {
        progressFill.classList.add(isEven ? 'is-full' : 'is-half');
      });
    }

    if (isEven) {
      progressMsg.innerHTML = '🎉 <strong>Your Buy 1 Get 1 offer is unlocked!</strong>';
      claimBtn.disabled = false;
      claimBtn.classList.remove('disabled');
    } else {
      progressMsg.innerHTML = '🚀 <strong>1 more item</strong> unlocks Buy 1 Get 1 Free!';
      claimBtn.disabled = true;
      claimBtn.classList.add('disabled');
    }
  }

  // ---- Hook into "Add to cart" so the popup opens only on additions ----
  function hookAddToCart() {
    // 1) Catch AJAX add-to-cart calls made via fetch (most modern themes,
    //    e.g. Dawn and its derivatives, use fetch for /cart/add.js).
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
      var isAddCall = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isAddCall && response.ok) {
          response
            .clone()
            .json()
            .then(function (data) {
              // Shopify returns an error object (with "status") on failed adds.
              if (!data.status) refreshCartAndShow();
            })
            .catch(function () {
              refreshCartAndShow();
            });
        }
        return response;
      });
    };

    // 2) Catch AJAX add-to-cart calls made via XMLHttpRequest (older/jQuery themes).
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isAddToCart = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      return originalOpen.apply(this, arguments);
    };
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__isAddToCart) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) refreshCartAndShow();
        });
      }
      return originalSend.apply(this, arguments);
    };

    // 3) Fallback for plain (non-AJAX) product forms that would otherwise
    //    do a full page reload: submit them via fetch instead.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('action') === null) return;
      if (form.getAttribute('action').indexOf('/cart/add') === -1) return;
      // If the theme already binds its own AJAX handler to this form, it will
      // have called preventDefault() before this listener runs on capture=false,
      // in which case e.defaultPrevented is true and we skip our fallback.
      if (e.defaultPrevented) return;

      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.status) refreshCartAndShow();
        })
        .catch(function (err) {
          console.error('Cart popup: add to cart failed', err);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();